import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
      <div className="bg-base-300">
      <div className="container mx-auto">
        <footer className="footer py-10 text-base-content">
        <div>
        <Link to='/'>
            <span className="text-2xl gap-2 text-primary flex justify-center items-center">
            <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 477.265 477.265"
      version="1.1"
      viewBox="0 0 477.265 477.265"
      xmlSpace="preserve"
      className="h-12 w-12 fill-primary"
    >
      <path d="M362.034 196.143h-80.609v-8.119c0-6.315-5.117-11.438-11.432-11.438H254.55v-45.881c0-26.564 21.618-48.182 48.182-48.182h94.358c8.802 0 15.926-7.131 15.926-15.926s-7.124-15.926-15.926-15.926h-94.358c-44.139 0-80.034 35.903-80.034 80.034v45.881h-15.443c-6.315 0-11.432 5.123-11.432 11.438v8.119h-80.609C51.589 196.143 0 247.738 0 311.364c0 63.642 51.589 115.23 115.214 115.23 44.403 0 82.88-25.149 102.119-61.939h42.599c19.238 36.79 57.716 61.939 102.103 61.939 63.642 0 115.231-51.589 115.231-115.23-.001-63.626-51.59-115.221-115.232-115.221zM170.799 323.092c0 4.525-3.671 8.188-8.181 8.188h-27.496v27.49c0 4.518-3.671 8.181-8.181 8.181h-23.454c-4.51 0-8.18-3.663-8.18-8.181v-27.49H67.809c-4.51 0-8.181-3.663-8.181-8.188v-23.438c0-4.526 3.671-8.189 8.181-8.189h27.498v-27.488c0-4.526 3.669-8.189 8.18-8.189h23.454c4.51 0 8.181 3.663 8.181 8.189v27.488h27.496c4.51 0 8.181 3.663 8.181 8.189v23.438zm151.405 6.166c-9.876 0-17.885-8.017-17.885-17.901 0-9.869 8.009-17.886 17.885-17.886 9.892 0 17.902 8.017 17.902 17.886 0 9.884-8.011 17.901-17.902 17.901zm36.892 36.891c-9.877 0-17.886-8.009-17.886-17.894 0-9.884 8.009-17.893 17.886-17.893 9.89 0 17.901 8.009 17.901 17.893 0 9.885-8.011 17.894-17.901 17.894zm0-73.782c-9.877 0-17.886-8.011-17.886-17.894 0-9.884 8.009-17.893 17.886-17.893 9.89 0 17.901 8.009 17.901 17.893s-8.011 17.894-17.901 17.894zm36.891 36.891c-9.877 0-17.886-8.017-17.886-17.901 0-9.869 8.009-17.886 17.886-17.886 9.892 0 17.901 8.017 17.901 17.886 0 9.884-8.009 17.901-17.901 17.901z"></path>
    </svg> Game E-Store
            </span>
          </Link>
          <p>A Store for Game Tools< br />Providing reliable Tools since 1992</p>
        </div> 
        <div>
          <span className="footer-title">Services</span> 
          <div className="link link-hover">Branding</div> 
          <div className="link link-hover">Design</div> 
          <div className="link link-hover">Marketing</div> 
          <div className="link link-hover">Advertisement</div>
        </div> 
        <div>
          <span className="footer-title">Company</span> 
          <div className="link link-hover">About us</div> 
          <div className="link link-hover">Contact</div> 
          <div className="link link-hover">Jobs</div> 
          <div className="link link-hover">Press kit</div>
        </div> 
        <div>
          <span className="footer-title">Legal</span> 
          <div className="link link-hover">Terms of use</div> 
          <div className="link link-hover">Privacy policy</div> 
          <div className="link link-hover">Cookie policy</div>
        </div>
      </footer>
      </div>
      </div>
    );
};

export default Footer;